var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12"}},[(_vm.isloading)?_c('loader'):_vm._e(),_c('h2',{staticClass:"pink--text tex--darken-1"},[_vm._v("Compra realizada con exito... "),_c('span',{staticClass:"black--text"},[_vm._v("redireccionando en "+_vm._s(_vm.cuenta_regresiva))])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }